import { useLayoutEffect } from 'react';

export function useBodyInset({ side = 'right', width, enabled }) {
    useLayoutEffect(() => {
        if (!enabled || typeof document === 'undefined') return undefined;

        const body = document.body;
        const property = side === 'left' ? 'paddingLeft' : 'paddingRight';
        const prevValue = body.style[property];

        body.style[property] = `${width}px`;

        return () => {
            body.style[property] = prevValue;
        };
    }, [side, width, enabled]);
}
